.ColorPickerWithActions {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 75%;
  z-index: 100;
  background-color: var(--base_color2);
  border: 1px solid var(--gray_light1);
  border-radius: 6px;
  box-shadow: var(--shadow_light);

  .ColorPickerWithActions-picker-wrapper input {
    color: var(--base_color1);
  }

  .ColorPickerWithActions-actions {
    display: flex;
    justify-content: flex-end;
    padding: 4px;
  }

  .sketch-picker {
    box-shadow: none !important;
  }
}
